/* eslint-disable camelcase */
import React from 'react';
import { jsx as ___EmotionJSX } from "@emotion/react";
export var availableFundsColumns = [{
  name: 'Кр. посредник',
  value: 'franchisee_name',
  width: '110px'
}, {
  name: 'Офис',
  value: 'office_name',
  width: '110px'
}, {
  name: 'Общо нал. средства',
  render: function render(_ref) {
    var total_balance = _ref.total_balance,
        currency = _ref.currency;
    return ___EmotionJSX("span", {
      "data-value": "total_balance"
    }, total_balance, " ", currency);
  }
}, {
  name: 'Общо нал. лихви и такси',
  render: function render(_ref2) {
    var commission_report_balance = _ref2.commission_report_balance,
        currency = _ref2.currency;
    return ___EmotionJSX("span", {
      "data-value": "total_balance"
    }, commission_report_balance, " ", currency);
  }
}, {
  name: 'Нал. за раздаване',
  render: function render(_ref3) {
    var available_balance = _ref3.available_balance,
        currency = _ref3.currency;
    return ___EmotionJSX("span", {
      "data-value": "total_balance"
    }, available_balance, " ", currency);
  }
}, {
  name: 'Общо събр. главници',
  render: function render(_ref4) {
    var total_collected_principals = _ref4.total_collected_principals,
        currency = _ref4.currency;
    return ___EmotionJSX("span", {
      "data-value": "total_collected_principals"
    }, total_collected_principals, " ", currency);
  }
}, {
  name: 'Общо събр. лихви',
  render: function render(_ref5) {
    var total_collected_interests = _ref5.total_collected_interests,
        currency = _ref5.currency;
    return ___EmotionJSX("span", {
      "data-value": "total_collected_interests"
    }, total_collected_interests, " ", currency);
  }
}, {
  name: 'Общо събр. такси',
  render: function render(_ref6) {
    var total_collected_fees = _ref6.total_collected_fees,
        currency = _ref6.currency;
    return ___EmotionJSX("span", {
      "data-value": "total_collected_fees"
    }, total_collected_fees, " ", currency);
  }
}];